<div class="px-7 py-5 overflow-y-auto" style="max-height: calc(100vh - 300px);">

  <!-- Step 1 -->
  <div class="flex items-center gap-3 mb-4">
    <div class="w-8 h-8 rounded-full bg-[var(--primary-dark)] text-white flex items-center justify-center text-[14px] font-bold shrink-0">1</div>
    <button (click)="openSelectFieldsDialog()"
      class="py-2 px-4 border-none rounded-lg text-xs font-semibold bg-[var(--primary-dark)] text-white cursor-pointer hover:opacity-90 transition-all">
      SELECT FIELDS
    </button>
    <div class="flex flex-col">
      <span class="text-[14px] font-bold text-[var(--base-text-dark)]">STEP 1 <span class="font-normal">- Select Fields</span></span>
      <span class="text-[11px] text-[var(--tertiary-text)]">Allocate your selected farms/fields to a season.</span>
    </div>
  </div>

  <!-- Selected Fields Chips -->
  <div *ngIf="selectedFields?.length" class="flex flex-wrap gap-1.5 mb-4 pl-11">
    <div *ngFor="let field of selectedFields"
      class="flex items-center gap-1.5 bg-[var(--app-base)] rounded-full py-1 pl-3 pr-1 text-[12px] font-semibold text-[var(--base-text-alt-dark)]">
      {{field.fieldName}}
      <span (click)="removeField(field.id)"
        class="w-5 h-5 rounded-full bg-[var(--notification-error)] text-white flex items-center justify-center text-[11px] cursor-pointer hover:opacity-80">×</span>
    </div>
  </div>

  <!-- Step 2 -->
  <div class="flex items-center gap-3 mb-4">
    <div class="w-8 h-8 rounded-full bg-[var(--primary-dark)] text-white flex items-center justify-center text-[14px] font-bold shrink-0">2</div>
    <div class="flex flex-col">
      <span class="text-[14px] font-bold text-[var(--base-text-dark)]">STEP 2 <span class="font-normal">- Add Information</span></span>
      <span class="text-[11px] text-[var(--tertiary-text)]">Populate the relevant inputs with information you wish to apply.</span>
    </div>
  </div>

  <!-- Field Input Form -->
  <div class="pl-11 mb-4">
    <app-season-field-input [inputData]="seasonFormData" [isInAnotherActiveSeason]="isInAnotherActiveSeason" (formDataChange)="onFormDataChange($event)"></app-season-field-input>
  </div>

  <!-- Step 3 -->
  <div class="flex items-center gap-3 pb-4">
    <div class="w-8 h-8 rounded-full bg-[var(--primary-dark)] text-white flex items-center justify-center text-[14px] font-bold shrink-0">3</div>
    <button (click)="openUpdateDialog()"
      class="py-2 px-4 border-none rounded-lg text-xs font-semibold bg-[var(--primary-dark)] text-white cursor-pointer hover:opacity-90 transition-all">
      Update
    </button>
    <div class="flex flex-col">
      <span class="text-[14px] font-bold text-[var(--base-text-dark)]">STEP 3 <span class="font-normal">- Update</span></span>
      <span class="text-[11px] text-[var(--tertiary-text)]">Apply the updated information to the selected fields.</span>
    </div>
  </div>

</div>
